import { PipesModule } from './../../../pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TableAtylDisplayComponent } from './table-atyl-display.component';
import { MaterialModule } from '../../../material.module';
import { TableContextMenuComponent } from './context-menu/context-menu.component';

@NgModule({
    imports: [CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule
    ],
    declarations: [TableAtylDisplayComponent,TableContextMenuComponent],
    exports: [TableAtylDisplayComponent,
        CommonModule, FormsModule,TableContextMenuComponent],
    entryComponents: [TableContextMenuComponent],	
})
export class TableAtylDisplayModule { }